import {Assignees} from './Assignees'
import {Development} from './Development'
import {Labels} from './Labels'
import {Reviewers} from './reviewers/Reviewers'
import {SidebarSection} from './SidebarSection'
import {SidebarActivity} from './activity/SidebarActivity'
import {ActivitySelector} from './activity/ActivitySelector'
import {OverviewMergeStatus} from './merge-status/OverviewMergeStatus'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {isFeatureEnabled} from '@github-ui/feature-flags'

// NOTE: this Overview info only works on the /overview page due to how its
// wired up with dataload. This is an intentional tradeoff while deciding if its worth having
// this panel at all
export function OverviewInfoContent() {
  return (
    <ErrorBoundary boundaryName="OverviewInfoPanel">
      <Suspense fallback={<div>Loading...</div>}>
        <OverviewInfo />
      </Suspense>
    </ErrorBoundary>
  )
}

function OverviewInfo() {
  return (
    <div className="d-flex flex-column gap-3">
      <SidebarSection title="Activity" headerAction={<ActivitySelector />}>
        <SidebarActivity />
      </SidebarSection>

      <OverviewMergeStatus />

      <SidebarSection title="Reviewers">
        <Reviewers />
      </SidebarSection>

      <SidebarSection title="Assignees">
        <Assignees />
      </SidebarSection>

      {isFeatureEnabled('prs_overview_labels') && (
        <SidebarSection title="Labels">
          <Labels />
        </SidebarSection>
      )}

      <SidebarSection title="Development">
        <Development />
      </SidebarSection>
    </div>
  )
}
